<template>
    <div
        v-if="projectLockStore.isLocked"
        class="locked-project-banner-container mb-3">
        <div class="locked-project-banner-background" />
        <div class="locked-project-banner-text px-1">{{ headerText }}</div>
        <div
            v-if="projectLockStore.lockedForProjectTable"
            class="locked-project-banner-subtext d-flex justify-content-center">
            <project-table-progress-message />
        </div>
    </div>
</template>

<script setup>
    import { computed, inject } from "vue";
    import { PC_RES_SYMBOL } from "_Main/injectionSymbols";
    import { useProjectLockStore } from "Projects/projectLockStore.js";
    import { KEYS, NAMESPACE } from "./i18n/projectLockedBanner.i18n";
    import { useResource } from "Util/i18n";
    import projectTableProgressMessage from "Forms/Components/Elements/projectTable/projectTableProgressMessage.vue";

    const res = inject(PC_RES_SYMBOL);
    const projectLockStore = useProjectLockStore();
    const { paymentUnderway, tableImportUnderway } = useResource(KEYS, NAMESPACE);

    const lockReason = computed(() => {
        if (projectLockStore.lockedForPendingPayment) {
            return paymentUnderway.value;
        }
        if (projectLockStore.lockedForProjectTable) {
            return tableImportUnderway.value;
        }
        return "";
    });

    const headerText = computed(() => {
        return res({
            namespace: NAMESPACE,
            key: KEYS.projectLockedHeader,
            values: { lockReason: lockReason.value }
        });
    });
</script>

<style lang="scss" scoped>
    .locked-project-banner-container {
        position: relative;
        width: 100%;
        overflow: hidden;
    }

    .locked-project-banner-background {
        background-image: url("Images/icons/yellow-and-black-stripes-repeat-lg.png");
        background-position: center left;
        background-repeat: repeat;
        margin-left: auto;
        margin-right: auto;
        opacity: 0.2;
        z-index: 9;
        width: 100%;
        height: 100%;
        position: absolute;
        overflow: hidden;
    }

    .locked-project-banner-text {
        position: relative;
        text-align: center;
        font-weight: 900;
        font-size: x-large;
        z-index: 10;
    }

    .locked-project-banner-subtext {
        position: relative;
        font-weight: 900;
        z-index: 10;
    }
</style>
